import { PersonHolderForm } from "@/modules/dashboard/cards/components/holder/PersonHolderForm";
import type { CreateIndividualIdentityRequest } from "@/modules/dashboard/cards/types/identity-form.types";
import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

import { VerificationService } from "../services/verificationService";
import type { CreateVerificationResponse } from "../types/verification-api.types";

const KYC_FORM_ID = "verification-kyc-person-form";

export interface KycPersonStepProps {
  onCreated: (response: CreateVerificationResponse) => void;
}

/**
 * KYC "Datos" step of the onboarding (marco A) — the natural-person twin of `KybCompanyStep`. Reuses the
 * existing `PersonHolderForm` and redirects its submit to `verification/person` with
 * `is_organization_identity: true`, so the organization's corporate identity is the person who owns it. The
 * created identity flows back via `onCreated` to drive the capture step.
 */
export function KycPersonStep({ onCreated }: KycPersonStepProps) {
  const { t } = useTranslations("verification");

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold text-foreground">{t("data_title")}</h2>
        <p className="text-sm text-muted-foreground">{t("data_subtitle")}</p>
      </div>

      <PersonHolderForm
        formId={KYC_FORM_ID}
        showSuccessToast={false}
        submit={(payload: CreateIndividualIdentityRequest) =>
          VerificationService.createPerson({ ...payload, is_organization_identity: true })
        }
        onSuccess={(response) => {
          if (response) onCreated(response);
        }}
      />

      <ColocaButton type="submit" form={KYC_FORM_ID} variant="primary" className="w-full">
        {t("button_continue")}
      </ColocaButton>
    </div>
  );
}
